import React from 'react';
import ClipboardIcon from '../assets/imgs/copy.svg';
// import { relative } from 'path';

class CopyText extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = { copySuccess: '' };
  }

  copyToClipboard(e) {
    const ele = document.createElement('input');
    ele.value =
      document.querySelector(`#${this.props.idToCopy}`).innerText ||
      document.querySelector(`#${this.props.idToCopy}`).value;
    ele.setAttribute('style', 'position: absolute; top: -99999999px');
    document.body.appendChild(ele);
    ele.focus();
    ele.select();
    document.execCommand('copy');
    this.setState({ copySuccess: this.props.copySuccess || '  Copied!  ' });
    setTimeout(() => {
      this.setState({ copySuccess: '' });
    }, 1000);
  }

  render() {
    return (
      <React.Fragment>
        {document.queryCommandSupported('copy') && (
          <div style={{ position: 'relative' }}>
            <img
              src={ClipboardIcon}
              onClick={this.copyToClipboard.bind(this)}
              style={
                Array.isArray(this.props.classNames) && this.props.classNames[0]
                  ? {}
                  : { width: 20, marginRight: 10 }
              }
              className={`hoverable ${
                Array.isArray(this.props.classNames) && this.props.classNames[0]
                  ? this.props.classNames[0]
                  : ''
              }`}
            />
            {this.state.copySuccess && (
              <div
                style={
                  Array.isArray(this.props.classNames) && this.props.classNames[1]
                    ? {}
                    : {
                        position: 'absolute',
                        top: '25px',
                        background: 'black',
                        color: 'white',
                      }
                }
                className={
                  Array.isArray(this.props.classNames) && this.props.classNames[1]
                    ? this.props.classNames[1]
                    : ''
                }>
                {this.state.copySuccess}
              </div>
            )}
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default CopyText;
